<template>
<div>
  <div v-if="spinner" class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
 <div v-else>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA NOTA DI CREDITO</strong>
  </h4>  
</div>

<div class="modal-body">
  <form v-on:submit.prevent="postXML()">  
  <p class="text-center mt-4" style="color:red"><strong>{{notFound}}</strong></p>  
  <div class="form-row">
    <div class="col">
      <strong><label>NUMERO SCONTRINO</label></strong>
      <input v-focus required type="number" @input="msg=''" ref="fiscalReceipNumber"  maxlength="4"  class="form-control" placeholder="" v-model="creditNote.fiscalReceiptNumber">
     
    </div>
    <div class="col">
      <strong><label>NUMERO RAPPORTO</label></strong>     
      <input type="number" required ref="zRepNumber"  @input="msg=''"   maxlength="4"  class="form-control" placeholder="" v-model="creditNote.zRepNumber">
     
    </div>
    <div class="col">
      <strong><label>DATA SCONTRINO</label></strong>
      <input type="text"  required ref="fiscalReceiptDate" @input="msg=''"  v-on:keydown="keyHandler($event,'Num')"  maxlength="6"  class="form-control" placeholder="GGMMAA" v-model="creditNote.fiscalReceiptDate">
       
    </div>
  </div>

  <button @click="$emit('close')" type="button" class="btn btn-secondary float-left mt-4">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
  </button>

  <button  type="submit" :disabled="bt_spinner==true"  class="btn btn-primary float-right mt-4">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>  

</form>
<p class="text-center mt-4" style="color:red"><strong>{{msg}}</strong></p>

</div>
</div>
</div> 

</div>

</template>

<script>
import axios              from 'axios'
import api                from '@/api'
import keyHandler         from '@/components/mixins/keyHandler'
import getSaleData        from '@/components/rt/mixins/getSaleData'
import fmt                from '@/components/mixins/fmt'

export default {
   mixins : [keyHandler,getSaleData,fmt],
   props  : ['data'],

  data() {
    return {
      
      creditNote : {
        fiscalReceiptNumber : ''
      },
      msg        : '',
      spinner    : true,
      notFound   : '',
      items      : [],
      payments   : [],
     
      bt_spinner : false
            
    };
  },
    directives: {
    focus: {
      // directive definition
      inserted: function(el) {
                
        el.focus();
      }
    }
  },

  
  async created () 
      {
        console.log('CREDIT NOTE',this.data) 
        this.getFiscalReceiptData()
        const data     = await this.getSaleData(this.data.saleId)
        this.items     = data[0]
        this.payments  = data[1]
      
        

      },  
  methods: 
  {
  
    getXML()    
          { 
            
            //const total                = this.payments[0].total                      
            const zRepNumber           = this.creditNote.zRepNumber
            const fiscalReceiptNumber  = this.creditNote.fiscalReceiptNumber
            const fiscalReceiptDate    = this.creditNote.fiscalReceiptDate
            /*const serialNumber         = this.data.serialNumber*/
            
            let xml  = '<Service>'            
            xml += '<cmd>' +  '=r/&' + fiscalReceiptDate + '/[' +  zRepNumber  + '/]' + fiscalReceiptNumber + '</cmd>'
            this.items.forEach(item =>
            {
          
              const price = this.fmt1(item.price).replace('.',"").replace(',','')          
              xml += '<cmd>=R1/$'+ price + '/ (' + item.barcode + ' ' + item.category + ')</cmd>'    
              
            }) 
            xml += '<cmd>=T1/' +  '</cmd>' 
            xml += '</Service>' 
            console.log('RCH CREDIT NOTE',xml)
            return xml
            

          },  
   
        

  async getFiscalReceiptData()
    {
      
      const sp         = {'sp'     : 'spSaleFiscalReceipt'}
      const data       = {'saleId' : this.data.receiptSaleId }
      const json       = Object.assign(data, sp)

      await api.post(json).then(res => {

        if(res.status == 200)
        {
          
          if(res.data.recordsets[0].length > 0)
          {
            this.creditNote.fiscalReceiptNumber  = res.data.recordsets[0][0].fiscalReceiptNumber
            this.creditNote.zRepNumber           = res.data.recordsets[0][0].zRepNumber
            this.creditNote.fiscalReceiptDate    = res.data.recordsets[0][0].fiscalReceiptDate
            this.creditNote.serialNumber         = res.data.recordsets[0][0].serialNumber
          }
          else
          {
            //this.notFound = 'DATI SCONTRINO DI VENDITA NON TROVATI.'
          }
        }
        else if(res.status==500)
          {
            console.log(res.data)
            
          }
          else
          {
            console.log(res)
            
          } 

        })
        .catch(err => 
      {
      
        console.log(err.message)
      }).finally(() => {
        this.spinner = false
       
      });
    },

    
    postXML()
    {
      
      if(this.checkData() == false)
      {
        return
      }
      
      this.bt_spinner = true
      const xml = this.getXML()
      axios({
               
               url    : this.data.url + '/service.cgi',
               method : 'post',
               data   : xml,
               headers : {'Content-Type': 'application/xml'}

             }).then(res => {
                
                this.bt_spinner = false
                console.log('RCH CREDIT NOTE RESPONSE',res)
                this.$emit('close')
               
             }).catch(err => {
              
               this.bt_spinner = false                            
               console.log('Errore RT',err)  
             })
       
    },       
    checkData()
    {
      
      this.msg = ''
      if(this.creditNote.fiscalReceiptDate.length != 6)
      {
        this.msg = 'DATA SCONTRINO NON VALIDA.'
        this.$nextTick(function () {
        
            this.$refs['fiscalReceiptDate'].focus()
        
        })
        return false
        
      }

        

      return true
     
    },
   

    
}
}

</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 10px;
}

::placeholder {
  color: rgb(106, 17, 223);
  opacity: 1; /* Firefox */
}



input {
  font-weight: bold;
}


</style>


